<template>
  <a-tabs v-model:activeKey="activeKey" :animated="false">
    <a-tab-pane key="1" :tab="'关注的人（' + page.allSize + '）'">
      <div class="followList" v-if="list.length > 0" style="min-height: 370px">
        <div class="followItem" v-for="item in list" :key="item.userId">
          <div class="followImg">
            <router-link
              :to="{ path: 'articles', query: { id: item.userId } }"
              target="_blank"
            >
              <img v-if="item.imgUrl" :src="imgSiteUrl + item.imgUrl" alt="" />
              <img
                v-else
                src="~@/assets/img/head1.png"
                alt=""
                style="background: #eee"
              />
            </router-link>
          </div>
          <div class="content">
            <div class="title">
              <router-link
                :to="{ path: 'articles', query: { id: item.userId } }"
                target="_blank"
              >
                {{ item.nickname }}
              </router-link>
            </div>
            <div class="summary">{{ item.presonalProfile }}</div>
            <div class="funs">
              <span class="numbers">{{ item.userExt.fans }}</span>
              <span class="fonts">个关注者</span>
            </div>
          </div>
          <div class="btn" v-if="loginUserId !== item.userId">
            <div v-if="item.followstate">
              <div class="checked">已关注</div>
              <div class="bmrn" @click="changeFollowState(item.userId,item)">
                取消关注
              </div> 
            </div>
            
            <a-button type="primary" v-else @click="notLogin(item)" class="focus" style="width: 86px;"
              >关注</a-button
            >
          </div>
        </div>
        <div class="page" v-if="page.allPage && page.allPage > 1">
          <a-pagination
            v-model:current="page.currentPage"
            :total="page.allSize"
            :show-total="(total) => `共 ${page.allSize} 篇`"
            :page-size="10"
            show-quick-jumper
            @change="
              (e) => {
                changePage(e, 1);
              }
            "
          />
        </div>
      </div>
      <div class="tab-blank" v-else>
        <a-empty />
      </div>
    </a-tab-pane>
    <a-tab-pane key="2" :tab="'关注者（' + page2.allSize + '）'">
      <div class="followList" v-if="list2.length > 0">
        <div class="followItem" v-for="item in list2" :key="item.userId">
          <div class="followImg">
            <router-link
              :to="{ path: 'articles', query: { id: item.userId } }"
              target="_blank"
            >
              <img v-if="item.imgUrl" :src="imgSiteUrl + item.imgUrl" alt="" />
              <img
                v-else
                src="~@/assets/img/head1.png"
                alt=""
                style="background: #eee"
              />
            </router-link>
          </div>
          <div class="content">
            <div class="title">
              <router-link
                :to="{ path: 'articles', query: { id: item.userId } }"
                target="_blank"
              >
                {{ item.nickname }}
              </router-link>
            </div>
            <div class="summary">{{ item.presonalProfile }}</div>
            <div class="funs">
              <span class="numbers">{{ item.userExt.fans }}</span>
              <span class="fonts">个关注者</span>
            </div>
          </div>
          

          <div class="btn" v-if="loginUserId !== item.userId">
            <div v-if="item.followstate">
              <div class="checked">已关注</div>
              <div class="bmrn" @click="changeFollowState(item.userId,item)">
                取消关注
              </div>
            </div>
            
            <a-button type="primary" class="focus" v-else @click="notLogin(item)" style="width: 86px"
              >关注</a-button
            >
          </div>

        </div>
        <div class="page" v-if="page2.allPage && page2.allPage > 1">
          <a-pagination
            v-model:current="page2.currentPage"
            :total="page2.allSize"
            :show-total="(total) => `共 ${page2.allSize} 篇`"
            :page-size="10"
            show-quick-jumper
            @change="
              (e) => {
                changePage(e, 2);
              }
            "
          />
        </div>
      </div>
      <div class="tab-blank" v-else>
        <a-empty />
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  computed,
  watch,
} from "vue";
import config from "../../until/configs";
import {
  getCookie,
  getLocalItem,
  confirmLogin,
  messageTips,
} from "@/until/tools";
import { useRoute } from "vue-router";
import Http from "../../until/http";
export default defineComponent({
  setup() {
    let activeKey = ref("1");
    let countData = reactive({ fans: 0, follows: 0 });
    const route = useRoute();
    const userId = computed(() => {
      return parseInt(route.query.id);
    });
    const loginUserId = computed(() => {
      return getLocalItem("userInfo")
        ? parseInt(getLocalItem("userInfo").userId)
        : null;
    });
    let list = ref([]);
    let list2 = ref([]);
    let page = ref({ allSize: 0 });
    let page2 = ref({ allSize: 0 });
    const changePage = (num,type) => {
      if(type===1) {
        Http.getFuns({
          userId: userId.value,
          currentPage: num,
          isFans: 0,
          keyword: keywords.value,
        }).then((res) => {
          if (res.followList) {
            list.value = res.followList;
          }
          if (res.page) {
            page.value = res.page;
          }
        });
      } else if(type===2) {        
        Http.getFuns({
        userId: userId.value,
          currentPage: num,
          isFans: 1,
          keyword: keywords.value,
        }).then((res) => {
          if (res.followList) {
            list2.value = res.followList;
          }
          if (res.page) {
            page2.value = res.page;
          }
        });
      }
    };
    const sid = computed(() => {
      return getCookie("z_sid");
    });

    const keywords = computed(() => {
      return route.query.keyword;
    });
    const changeFollowState = (resId, item) => {
      if (!sid.value) {
        confirmLogin();
        return false;
      }
      if (loginUserId.value == userId.value) {
        Http.deleteAuthor({ resId: resId, sid: sid }).then(() => {
          if(activeKey.value==='1') {
            const {allSize,currentPage,pageSize} = page.value;                  
            let allPage = Math.ceil((allSize-1)/pageSize);
            let pagex;
            if(allPage<currentPage) {
              pagex = allPage;
            } else {
              pagex = currentPage;
            }
            if(pagex<1) {
              pagex=1;
            }
            changePage(pagex,1);
          } else {
            const {allSize,currentPage,pageSize} = page2.value;                  
            let allPage = Math.ceil((allSize-1)/pageSize);
            let pagex;
            if(allPage<currentPage) {
              pagex = allPage;
            } else {
              pagex = currentPage;
            }
            if(pagex<1) {
              pagex=1;
            }
            changePage(pagex,2);
          }
          //getList(1);
        });
      } else {
        let params = {
          resId: item.userId,
          flag: item.status ? 1 : 0,
        };
        Http.foucsAuthor(params).then((res) => {
          if (res) {
            if (res.success) {
              item.followstate = !item.followstate;
              messageTips("关注成功", 3);
            } else {
              messageTips(res.message, 1);
            }
          }
        });
      }
    };
    const notLogin = (item) => {
      if (!sid.value) {
        confirmLogin();
        return false;
      }
      let params = {
        resId: item.userId,
        flag: item.status ? 1 : 0,
      };
      Http.foucsAuthor(params).then((res) => {
        if (res) {
          if (res.success) {
            item.followstate = !item.followstate;
            messageTips("关注成功", 3);
          } else {
            //不能关注自己
            messageTips(res.message, 1);
          }
        }
      });
    };
    const imgSiteUrl = computed(() => {
      return config.imgSiteUrl;
    });
    let getList = (num) => {
      Http.getFuns({
        userId: userId.value,
        currentPage: num,
        isFans: 0,
        keyword: keywords.value,
      }).then((res) => {
        if (res.followList) {
          list.value = res.followList;
        }
        if (res.page) {
          page.value = res.page;
        }
      });
      Http.getFuns({
        userId: userId.value,
        currentPage: num,
        isFans: 1,
        keyword: keywords.value,
      }).then((res) => {
        if (res.followList) {
          list2.value = res.followList;
        }
        if (res.page) {
          page2.value = res.page;
        }
      });
    };
    watch(keywords, () => {
      getList(1);
    });
    onMounted(() => {
      getList(1);
    });
    return {
      sid,
      changeFollowState,
      imgSiteUrl,
      list,
      list2,
      page2,
      page,
      changePage,
      getList,
      activeKey,
      countData,
      loginUserId,
      userId,
      notLogin,
    };
  },
});
</script>
<style lang="scss" scoped>
.followList{
  min-height: 370px !important;
}
.followItem {
  height: 120px;
  box-sizing: border-box;
  display: flow-root;
  border-bottom: 1px solid #f6f6f6;
  padding-top: 10px;
  &:not(:first-child) {
    padding-top: 20px;
  }
  .followImg {
    width: 72px;
    height: 72px;
    text-align: center;
    float: left;
    margin-right: 10px;
    a {
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }
  .content {
    width: 590px;
    float: left;
    .title {
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      color: #333;
    }
    .summary {
      padding: 0;
      box-sizing: border-box;
      color: #666;
      background: none;
      font-size: 15px;
      height: 34px;
      line-height: 34px;
      width: 686px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .funs {
      .numbers {
        vertical-align: top;
        font-size: 15px;
        color: #e75934;
      }
      .fonts {
        vertical-align: top;
        font-size: 15px;
        margin-left: 4px;
        color: #666;
      }
    }
  }
  .btn {
    float: right;
    cursor: pointer;
    margin-top: 20px;
    line-height: 30px;
    text-align: center;
    &:hover {
      .checked {
        display: none;
      }
      .bmrn {
        display: block;
      }
    }
    .checked {
      color: #e75934;
      background-color: #fff;
      border: 1px solid #e75934;
      width: 86px;
      border-radius: 2px;
    }
    .bmrn {
      display: none;
      border: 1px solid #8590a6;
      color: #fff;
      background: #8590a6;
      width: 86px;
      border-radius: 2px;
    }
  }
}
.page {
  text-align: center;
  padding:30px 0 20px 0;
}
</style>